import { DeviceConfigurationUpdateDtoDeviceConfigurationUpdateResponseEnum } from '../cobra-backend-client/api';

export const ConfigurationUpdateMessages = {
  [DeviceConfigurationUpdateDtoDeviceConfigurationUpdateResponseEnum.ErrIncorrectChecksum]: 'Checksum mismatch - file corrupted or modified',
  [DeviceConfigurationUpdateDtoDeviceConfigurationUpdateResponseEnum.ErrIncorrectVersion]: 'Version mismatch - configuration not compatible',
  [DeviceConfigurationUpdateDtoDeviceConfigurationUpdateResponseEnum.ErrIncorrectLength]: 'File length error - file damaged',
  [DeviceConfigurationUpdateDtoDeviceConfigurationUpdateResponseEnum.ErrUnknown]: 'Unknown error occurred',
} as const;
